import type { ReactElement } from "react";
import { cloneElement, isValidElement } from "react";
import { useIntercomContext } from "../contexts/IntercomContext";

type WithHoverHandlers = {
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
};
interface Props {
  mode: "opacity" | "hide";
}
const IntercomLauncherDependantElement = <P extends WithHoverHandlers>({
  mode,
  children,
}: Props & { children: ReactElement<P> }) => {
  const { addEffect, removeEffect } = useIntercomContext();

  if (!isValidElement(children)) {
    return <>{children}</>;
  }

  return cloneElement(children, {
    onMouseEnter: (e: React.MouseEvent) => {
      children.props.onMouseEnter?.(e);
      addEffect(mode);
    },
    onMouseLeave: (e: React.MouseEvent) => {
      children.props.onMouseLeave?.(e);
      removeEffect(mode);
    },
  } as P);
};

export default IntercomLauncherDependantElement;
